import env from '@tencent/vft-common/env';
import KVParser from '@tencent/vft-common/KVParser';
import cookie from '@tencent/vft-common/cookie';
import { getUrlParam } from '@tencent/vft-common/util';

export function isFunction(fn) {
  return typeof fn === 'function';
}
/**
 * 格式化数据
 * @param {String|Object} data 参数
 * @param {Boolean} reportBoss 是否上报鹰眼
 */
const kvParser = new KVParser({ skipEmpty: true });
export function query2obj(data) {
  let result = {};
  if (typeof data === 'string') {
    result = kvParser.parse(data);
  }
  return result;
}
/**
 * 获取上报类型
 * @param {String} modifiers 指令修饰符
 *
 * @return {String}
 */
export function getReportType(modifiers) {
  const types = Object.keys(modifiers);
  if (types.includes('expose') && types.includes('click')) {
    return 'all';
  }
  return Object.keys(modifiers)[0] || 'all';
}
/**
 * 获取平台号
 */
export function getPlatform() {
  const platform = {
    kidapp: {
      iphone: 8004,
      aphone: 8003,
      ipad: 8005,
      apad: 8006,
    },
    app: {
      iphone: 7,
      aphone: 8,
      ipad: 5,
      apad: 6,
      windows: 2000,
      mac: 2001,
    },
    weishi: {
      iphone: 31,
      aphone: 32,
    },
    qqbrowser: {
      iphone: 33,
      aphone: 34,
    },
    qqnews: {
      iphone: 35,
      aphone: 36,
    },
    web: 1000,
    h5: 3000,
  };
  const ua = window.navigator.userAgent;
  // mp_env=qb/news/qq
  const mpEnv = getUrlParam('mp_env');
  // 是否腾讯新闻
  const isQQNews = /\s+(qqnews|qnreading)/.test(ua);
  // 是否qq浏览器
  const isQB = env.isIos ? /mqqbrowser/gi.test(ua) : (!!window.qb_bridge || !!(window.mtt && window.mtt.getBrowserParam));
  let app;
  switch (true) {
    case isQB || mpEnv === 'qb':
      app = 'qqbrowser';
      break;
    case env.isWeishi:
      app = 'weishi';
      break;
    case isQQNews || mpEnv === 'news':
      app = 'qqnews';
      break;
    case env.isBaseApp:
      app = 'app';
      break;
    case env.isKidApp:
      app = 'kidapp';
      break;
    default:
  }
  if (platform[app]?.[env.device]) {
    return platform[app][env.device];
  }
  return env.isWeb ? platform.web : platform.h5;
}

function generatePvid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }

  return [s4(), s4(), s4(), s4()].join('');
}

let pvid = cookie.get('pgv_pvid');
export function getPvid() {
  if (!pvid || pvid.length < 8) {
    // 兜底，如果取不到 pvid 情况下，生成一个pvid
    pvid = generatePvid();
    cookie.set('pgv_pvid', pvid, {
      expires: 2592000,
      domain: location.host.split('.').slice(-2).join('.'),
      path: '/',
    });
  }
  return pvid;
}
